import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionStateForm_UpdateMissionState_Mutation = graphql(`
  mutation MissionStateForm_UpdateMissionState(
    $actionId: Id!
    $actionPayload: MissionUpdateStateActionPayloadInput
    $missionId: Id!
    $versionData: VersionDataInput
  ) {
    updateMissionState(
      actionId: $actionId
      actionPayload: $actionPayload
      missionId: $missionId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type MissionStateForm_UpdateMissionState_Result = ResultOf<
  typeof MissionStateForm_UpdateMissionState_Mutation
>;

export const useUpdateMissionStateMutation = () =>
  useGraphQLMutation(MissionStateForm_UpdateMissionState_Mutation);
